export const EDUCATION_TAG_TYPE = 'Education';
